const initialState = {
  reports: [],
};
const mediaPostReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_MEDIA_POST_REPORTS":
      return { ...state, reports: action.payload };
    case "UPDATE_ENABLE_DISABLE_STATUS":
      return (state = {
        ...state,
        reports: state?.reports?.map((reports) =>
            reports._id === action.payload._id ? action?.payload : reports
        ),
      });
    default:
      return state;
  }
};

export default mediaPostReportReducer;
